import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{documentRequestUserId}/consolidated-data']['GET'];
type Input = ThisApi['params'];

const getConsolidatedData = async ({ documentRequestUserId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(`/document-request-users/${documentRequestUserId}/consolidated-data`);
  return response.data;
};

export default getConsolidatedData;
